// src/components/AdminNavbar.jsx
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminNavbar = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user || user.role !== "admin") return null;

  return (
    <div className="bg-[#1a1a1a] text-white px-4 py-3 flex flex-wrap justify-center gap-4 shadow-md z-50">
      <button
        onClick={() => navigate("/dashboard")}
        className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded text-sm"
      >
        🎮 Dashboard
      </button>
      <button
        onClick={() => navigate("/stats")}
        className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded text-sm"
      >
        📊 Stats
      </button>
      <button
        onClick={() => navigate("/admin")}
        className="bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded text-sm"
      >
        👤 Ajouter Gerant
      </button>
      <button
        onClick={() => navigate("/caisse")}
        className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded text-sm"
        >Caisse
        </button>
    </div>
  );
};

export default AdminNavbar;
